import React from "react"
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"
import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper"

import * as styles from "./ImageWidget.module.scss"

///
// The options for the orientation can either be "portrait" or "landscape"
///
const ImageWidget = ({blok}) => {
  return (
    <WidgetWrapper blok={blok}>
      <div className={blok.image_orientation === "portrait" ? styles.portrait : styles.landscape}>
        <StoryblokImage sbImageData={blok.image} />
      </div>
    </WidgetWrapper>
  )
}

export default ImageWidget